import {Box, Typography} from '@mui/material';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {useRouter} from 'next/router';
import {useEffect, useState, type FC} from 'react';
import {useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {jobDetailService} from '@jobseeker/common-core/services';

const isHirist = process.env.NEXT_PUBLIC_APP_NAME === 'hirist';

const IconBadge: FC = () => (
  <Box flexShrink={0} width={{xxs: 44, md: 44}} height={{xxs: 56, md: 44}}>
    <svg width="100%" height="100%" viewBox="0 0 44 44" fill="none">
      <rect width="44" height="44" rx="22" fill="#FBDDD0" />
      <circle cx="22" cy="22" r="9" stroke="#F0491E" strokeWidth="2" />
      <path
        d="M22 16V22L26 24"
        stroke="#F0491E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);

const PendingApplicationBanner: FC = () => {
  const router = useRouter();
  const isLoggedIn = useSelector((state: AppState) => state.auth.isLoggedIn);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    if (!isHirist || !isLoggedIn) return;
    jobDetailService.getPendingJobsCount().then(response => {
      setPendingCount(response?.data?.count || 0);
    });
  }, [isLoggedIn]);

  if (!isHirist || pendingCount <= 0) return null;

  return (
    <Box
      sx={{
        mb: 3.5,
        ml: 2,
        width: {xxs: '92%', md: '94%', lg: '95%', xl: '96%'},
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        bgcolor="#FFF3EE"
        border="1px solid #F8D5C7"
        borderRadius="16px"
        px={3}
        py={2.25}
        boxShadow="0px 4px 12px 0px rgba(153,64,26,0.1)"
      >
        <Box display="flex" alignItems="center" gap={2}>
          <IconBadge />
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Typography fontWeight={600} fontSize="16px" color="#1A1A1A">
              Pending application
            </Typography>
            <Typography fontSize="14px" color="#5C5C5C">
              You have {pendingCount} applications in progress — complete your
              profile to get noticed.
            </Typography>
          </Box>
        </Box>
        <Button
          onClick={() =>
            router.push('/registration/addPersonalDetails?ref=MetaJobfeed')
          }
          sx={{
            bgcolor: '#FF6A3D',
            color: '#fff',
            px: 2.5,
            py: 1.375,
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '14px',
            whiteSpace: 'nowrap',
            textTransform: 'none',
            width: {xxs: '100%', md: 'auto'},
            textAlign: 'center',
            justifyContent: 'center',
            ':hover': {
              bgcolor: '#e85a2e',
            },
          }}
        >
          Complete application
        </Button>
      </Box>
    </Box>
  );
};

export default PendingApplicationBanner;
